function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-187.957 -212.75)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M212.207,221.375A10.625,10.625,0,1,0,201.582,232,10.637,10.637,0,0,0,212.207,221.375Zm-8.354,4.875a3.541,3.541,0,0,1-1.1.511v.524a1.175,1.175,0,1,1-2.35,0v-.551a4.182,4.182,0,0,1-.586-.219,3.216,3.216,0,0,1-1.693-1.82,1.175,1.175,0,1,1,2.2-.822.866.866,0,0,0,.484.511,1.875,1.875,0,0,0,1.684-.054.81.81,0,0,0,.271-.971c-.186-.406-1.026-.706-1.582-.9a4.629,4.629,0,0,1-2.928-2.14,3.181,3.181,0,0,1,1.052-3.868,3.542,3.542,0,0,1,1.1-.51v-.472a1.175,1.175,0,1,1,2.35,0v.5a4.164,4.164,0,0,1,.586.219,3.216,3.216,0,0,1,1.693,1.82,1.175,1.175,0,1,1-2.2.822.865.865,0,0,0-.484-.511,1.875,1.875,0,0,0-1.684.054.81.81,0,0,0-.271.971c.186.406,1.026.706,1.582.9a4.629,4.629,0,0,1,2.928,2.14,3.181,3.181,0,0,1-1.052,3.868Z",
  transform: "translate(-3 2)"
}));

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.25,
    height: 21.25,
    viewBox: "0 0 21.25 21.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.a7e2a995.svg";
export { ForwardRef as ReactComponent };